import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

const Test = (props) => {
  useEffect(() => {
    props.history.push("/");
    window.location.reload(true);
    localStorage.clear();
  }, []);
  return <label className="text-success">Cache & Local storage removed successfully!</label>;
};

export default withRouter(Test);
